var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "right-start",
        title: "添加",
        width: "156",
        trigger: "click",
        "popper-class": "add-node-popover",
      },
    },
    [
      _c("div", { staticClass: "node-select" }, [
        _c(
          "div",
          { staticClass: "node-name", on: { click: _vm.addApprovalNode } },
          [_c("span", [_vm._v("审批人")])]
        ),
        _c("div", { staticClass: "node-name", on: { click: _vm.addCcNode } }, [
          _c("span", [_vm._v("抄送人")]),
        ]),
        _c(
          "div",
          { staticClass: "node-name", on: { click: _vm.addTaskNode } },
          [_c("span", [_vm._v("办理人")])]
        ),
      ]),
      _c("el-button", {
        attrs: {
          slot: "reference",
          icon: "el-icon-plus",
          type: "primary",
          size: "small",
          circle: "",
        },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }